define((require) => {
    "use strict";

    var ImprovedView     = require("editor/zbone/ImprovedView"),
        _                = require("underscore");

    /**
     * Calculates the changing parts of the css for a backdrop viewer. Takes the backdrop model the
     * experience size and returns a promise that resolves to the new css.
     *
     * @param {BackdropModel} backdrop             The backdrop model.
     * @param {width: Number, height: Number} size The experience size as {width, height}.
     * @return {Object}                            Object with new css properties
     *
     */
    function calculateCss(backdrop, size) {
        var css = _.extend({
            backgroundColor: "",
            backgroundImage: "",
            margin: 0,
            outline: ""
        }, size);

        if (backdrop.isFitContainer()) {
            css.width += 20;
            css.height += 20;
            css.margin = -10;
            css.outline = "1px dashed #c6c6c6";
        }

        if (backdrop.isTypeImage()) {
            css.backgroundImage = "url(" + (backdrop.getImageURL() || "") + ")";
        } else {
            css.backgroundColor = backdrop.getColor();
        }

        return css;
    }

    /**
     * A Backdrop viewer.
     *
     * @class BackdropViewer
     * @constructor
     *
     * @cfg {Backdrop} model The backdrop model to display in the region.
     * @cfg {ExperienceModel} experience The Experience model.
     */
    return ImprovedView.extend({
        // No need for a template
        template: function() {
            return "";
        },

        className: "backdrop-viewer",

        modelEvents: {
            "change": "_updateBackdrop"
        },

        onShow: function() {
            this._updateBackdrop();
        },

        _updateBackdrop: function() {
            this.$el.css(calculateCss(this.model, this.options.experience.pick("width", "height")));
        }
    }, {
        // Exposed for testing purposes
        calculateCss: calculateCss
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/BackdropViewer.js